import Enquiry from "../enquiry/Enquiry";
import Form from "../enquiry/Form";
const EnquiryForm = () => {
  return (
    <>
      <Form />
    </>
  );
};

export default EnquiryForm;
